module.exports = __webpack_public_path__ + "static/linhas-loft-0a380df658f1d58ff60ffdf8931870eb.png";